import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { certificatesActions } from '../actions/certificates.actions';
import { selectCertificates, selectCertificatesLoaded, selectCertificatesLoading } from '../selectors/certificates.selectors';

@Injectable({ providedIn: 'root' })
export class CertificatesFacade {
    private readonly store = inject(Store);

    readonly certificates = this.store.selectSignal(selectCertificates);
    readonly loading = this.store.selectSignal(selectCertificatesLoading);
    readonly loaded = this.store.selectSignal(selectCertificatesLoaded);

    readonly certificates$ = this.store.select(selectCertificates);
    readonly loading$ = this.store.select(selectCertificatesLoading);
    readonly loaded$ = this.store.select(selectCertificatesLoaded);

    getCertificates(): void {
        this.store.dispatch(certificatesActions.getCertificates());
    }

    clear(): void {
        this.store.dispatch(certificatesActions.clear());
    }
}
